import React, { useState } from "react";
import { CalendarField } from '../../../helpers';
import { RadioButton } from "primereact/radiobutton";
import { useSelector, useDispatch } from 'react-redux';

import { DuplicateRequirementSchem,duplicateRequirementInitialState  } from '../../../validation/duplicateBuyerReqValidation';
import { validateInputs } from '../../../utils';
import { raiseToast } from '../../../services/redux/reducers/toast/toast';

const DuplicateBuyerReqDateModal = (props) => {
    const { handleDuplicateBuyerRequirement, selectedReq, setSelectedReq, setDuplicateBuyerReqLoading, onCancel} = props
    const [isRouted, setRouted] = useState('');
    const [requirementDate, setRequirementDate] = useState(null)
    const dispatch = useDispatch()

    const lastMonthDate = new Date()
    lastMonthDate.setMonth(new Date().getMonth() - 1)
    const nextMonthDate = new Date()
    nextMonthDate.setMonth(new Date().getMonth() + 1)

    const handleRoutedChange = (event) => {
        setRouted(event.target.value);
    };

    const handleRequirementCreatedTime = (e) => {
        setRequirementDate(e.value)
    }

    const handleSubmit = async () => {
        selectedReq.isRouted = isRouted
        selectedReq.requirementDate = requirementDate
        setSelectedReq(selectedReq)

        const validationRes = await validateInputs(DuplicateRequirementSchem, selectedReq)

        if (validationRes.error) {
            if(validationRes.error.requirementDate){
                dispatch(raiseToast({severity:'error', detail: validationRes.error.requirementDate, life: 3000}))
            }
            else if(validationRes.error.isRouted){
                dispatch(raiseToast({severity:'error', detail: validationRes.error.isRouted, life: 3000}))
            }
        }else{
            setDuplicateBuyerReqLoading(true)
            handleDuplicateBuyerRequirement()
        }
    };

    const handleCancel = () => {
        onCancel();
    };

    return (
        <div className="p-card flex flex-column pb-2">
            <div className="flex flex-row mb-2">
                <div className="flex flex-column mr-2">
                    <div className='mb-2'><label className='font-medium text-sm'>Requirement Date</label><span className="required-mark">*</span></div>
                    <CalendarField dateFormat='dd/mm/yy' value={requirementDate} minDate={lastMonthDate} maxDate={nextMonthDate} onChange={handleRequirementCreatedTime} showTime hourFormat="12" showIcon required />
                </div>
                <div className="flex flex-column p-2 mx-5">
                    <div><span className='text-sm'>Routed</span><span className="required-mark">*</span></div>
                    <div className="flex flex-row mt-1">
                        <div className="flex flex-row mr-3">
                            <RadioButton inputId="yes" value="Yes" onChange={handleRoutedChange} checked={isRouted === 'Yes'} />
                            <label htmlFor="yes" className="ml-1 text-sm">Yes</label>
                        </div>
                        <div className="flex flex-row">
                            <RadioButton inputId="no" value="No" onChange={handleRoutedChange} checked={isRouted === 'No'} />
                            <label htmlFor="no" className="ml-1 text-sm">No</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-row mt-2 justify-end mt-5 ml-auto">
                <button className="p-button p-button-success mr-2" style={{ backgroundColor: "#00baaa" }} onClick={handleSubmit}>DUPLICATE</button>
                <button className="p-button p-button-danger" onClick={handleCancel}>CANCEL</button>
            </div>
        </div>
    );
};

export default DuplicateBuyerReqDateModal;